/* eslint-disable @typescript-eslint/naming-convention */
import { Capacitor } from '@capacitor/core';
import { Platform } from '../enums/platform.enum';
import { IGradientBtnConfig } from '../interfaces/gradient-btn-config';
import { EDateFormat } from '../enums/date.enum';

export const PcButtonType = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
};

export const PcButtonIcon = {
  APP: 'assets/document.svg',
  LEADS: 'assets/bar-chart.svg',
  QUOTES: 'assets/folder.svg',
  CLIENTS: 'assets/clients.svg',
  LEFT_ARROW: 'assets/left-arrow.svg',
  RIGHT_ARROW: 'assets/right-arrow.svg',
  RED_RIGHT_CARET: 'assets/red-right-caret.svg',
  RED_LEFT_CARET: 'assets/red-left-caret.svg',
  RED_RIGHT_ARROW: 'assets/red-right-arrow.svg',
  ARROW_BUTTON: 'assets/arrow-button.svg',
  TOGGLE_UP: 'assets/chevron-up.svg',
  LEFT_CHEVRON: 'assets/chevron-left.svg',
  DOWN_CHEVRON: 'assets/chevron-down.svg',
  UP_CHEVRON: 'assets/chevron-up.svg',
  X_CLOSE: 'assets/x-close.svg',
  X_CLOSE_BOLD: 'assets/x-close-bold.svg',
  X_CLOSE_GRAY: 'assets/x-close-gray.svg',
  POPUP_X_CLOSE: 'assets/popup-x-close.svg',
  SEARCH_MAGNIFIER: 'assets/search.svg',
  SEARCH_MAGNIFIER_GRAY: 'assets/search-gray.svg',
  FILTER_SEARCH: 'assets/filter-search.svg',
  EXPORT: 'assets/export.svg',
  MENU: 'assets/dot-menu.svg',
  USER: 'assets/user.svg',
  USER_TEST: 'assets/userTest.svg',
  USERS: 'assets/users.svg',
  PHONE: 'assets/phone.svg',
  EMAIL: 'assets/mail-open-outline.svg',
  DOCUMENT: 'assets/document.svg',
  DOCUMENT_RED: 'assets/document-red.svg',
  CERT_OF_COVERAGE: 'assets/icons/cert_of_coverage.svg',
  DOCUMENTS: 'assets/documents.svg',
  DOCUMENTS_SECTION: 'assets/documents-section.svg',
  OUTLINE: 'assets/create-outline.svg',
  CALENDAR: 'assets/calendar.svg',
  CALENDAR_DETAILED: 'assets/calendar-detailed.svg',
  CHART: 'assets/bar-chart.svg',
  CHART_RED: 'assets/folder.svg',
  FOLDER: 'assets/folder.svg',
  ROLL_PAPER_TXT: 'assets/roll-paper-txt.svg',
  ROLL_PAPER_USER: 'assets/roll-paper-user.svg',
  CIRCLE_RIGHT: 'assets/arrow-buttons.svg',
  SUCCESS_V: 'assets/success-v.svg',
  ERROR_ROUNDED: 'assets/error-rounded.svg',
  QUICK_ACTIONS: 'assets/quick-actions.svg',
  NAVBAR_BURGER: 'assets/burger.svg',
  COPY: 'assets/copy-outline.svg',
  CHECK_CIRCLE: 'assets/checked-circle.svg',
  DOWN_ARROW: 'down-arrow',
  CIRCLE_LOADER: 'circle-loader-gray',
  CIRCLE_CHECKBOX_SELECTED: 'assets/circle-checkbox-selected.svg',
  CIRCLE_CHECKBOX_UNSELECTED: 'assets/circle-checkbox-unselected.svg',
  CHECKBOX_UNSELECTED: 'assets/checkbox-unselected.svg',
  CHECKBOX_SELECTED: 'assets/checkbox-selected.svg',
  CHECKBOX_SELECTED_DISABLED: 'assets/checkbox-selected-disabled.svg',
  TRASH: 'assets/trash.svg',
  TRASH_BLUE: 'assets/trash-blue.svg',
  TRASH_BLACK: 'assets/trash-black.svg',
  WHEN_DEPARTURE_SM: 'assets/when-departure-sm.svg',
  WHEN_RECTANGLE: 'assets/when-rectangle.svg',
  WHEN_RECTANGLE_DESK: 'assets/when-rectangle-desk.svg',
  CIRCLE_MINUS_PRIMARY: 'assets/circle-minus-primary.svg',
  CIRCLE_PLUS_PRIMARY: 'assets/circle-plus-primary.svg',
  CIRCLE_MINUS_SM_PRIMARY: 'assets/circle-minus-sm-primary.svg',
  CIRCLE_PLUS_SM_PRIMARY: 'assets/circle-plus-sm-primary.svg',
  CIRCLE_PLUS_RED: 'assets/circled-plus-red.svg',
  CIRCLE_PLUS_DISABLED: 'assets/circled-plus-disabled.svg',
  CIRCLE_PLUS_RED_BORDER: 'assets/circled-plus-red-border.svg',
  CIRCLE_MEMBER: 'assets/icons/circle-member.svg',
  FINGER_PRINT: 'assets/fingerprint.svg',
  FACE_ID: 'assets/face-id.svg',
  LIKE_BUTTON: 'assets/like-button.svg',
  LIKE_BUTTON_SELECTED: 'assets/like-button-selected.svg',
  REFRESH: 'assets/refresh.svg',
  FILTER: 'assets/filter.svg',
  VIEW: 'assets/view.svg',
  DELETE: 'assets/delete.svg',
  CHEVRON_DOWN_BLUE: 'assets/chevron-down-blue.svg',
  CHEVRON_UP_BLUE: 'assets/chevron-up-blue.svg',
  CHEVRON_LEFT_BLUE: 'assets/chevron-left-blue.svg',
  LOCK: 'assets/icons/lock.svg',
  PLUS: 'assets/icons/plus.svg',
  SHIELD_CHECK_MARK: 'assets/icons/shield-check-mark.svg',
  POLICY: 'assets/policy.svg',
  POLICIES: 'assets/policy.svg',
  CLAIMS: 'assets/claims.svg',
  TRASH_RED: 'assets/trash-red.svg',
  DATE_SELECT_RECTANGLE: 'assets/date-select-rectangle.svg',
  AIRPLANE_RETURN_TRIP: 'assets/airplane-return-trip.svg',
  AIRPLANE_RETURN_TRIP_DESK: 'assets/airplane-return-trip-desk.svg',
  ROCKET: 'assets/rocket.svg',
  CHECKMARK: 'assets/checkmark.svg',
  EDIT_STEP: 'assets/edit-step.svg',
  DONE_STEP: 'assets/done-step.svg',
  NUMBER_STEP: 'assets/number-step.svg',
  BLUE_PHONE: 'assets/blue-phone.svg',
  SUCCESS_EDIT_POLICY: 'assets/success-edit-policy.svg',
  ATTACH_FILE: 'assets/attach-doc.svg',
  EXCLAMATION_MARK_WARNING: 'assets/warning-mark.svg',
  EDIT_TRAVELER: 'assets/edit-traveler.svg',
  ENVELOPE_BLACK: 'assets/envelope-black.svg',
  PHONE_BLACK: 'assets/phone-black.svg',
  ACCIDENT: 'assets/icons/postpaid-claims/accident.svg',
  DENTAL: 'assets/icons/postpaid-claims/dental.svg',
  ILLNESS: 'assets/icons/postpaid-claims/illness.svg',
  LUGGAGE: 'assets/icons/postpaid-claims/luggage.svg',
  PREGNANT: 'assets/icons/postpaid-claims/pregnant.svg',
  THIRD_PARTY: 'assets/icons/postpaid-claims/third-party.svg',
  VALUABLE: 'assets/icons/postpaid-claims/valuable.svg',
  CANCELLATION: 'assets/icons/postpaid-claims/cancellation.svg',
  SHORTEN: 'assets/icons/postpaid-claims/shorten.svg',
  FAMILY_REUNION: 'assets/icons/postpaid-claims/family.svg',
  LOCKDOWN: 'assets/icons/postpaid-claims/lockdown.svg',
  PANDEMIC: 'assets/icons/postpaid-claims/pandemic.svg',
  DEFAULT: 'assets/icons/postpaid-claims/default.svg',
  CAR_RENTAL: 'assets/icons/postpaid-claims/car.svg',
  CLAIM_PHONE: 'assets/icons/postpaid-claims/phone.svg',
  LAPTOP: 'assets/icons/postpaid-claims/laptop.svg',
  CAMERA: 'assets/icons/postpaid-claims/camera.svg'
};

export const PcIcon = {
  PASSPORTCARD: 'assets/passportcard.svg',
  UNDER_CONSTRUCTION: 'assets/under-constructions.svg',
  BAG: 'assets/bag.svg',
  PLUS: 'assets/plus.svg',
  APPLICANT: 'assets/applicant.svg',
  APPLICANT_HEART: 'assets/images/Applicant.svg',
  APPLICANT_ICON: 'assets/applicant-cart.svg',
  SUITCASE: 'assets/suitcase.svg',
  BENEFITS: 'assets/benefits.svg',
  QUESTION: 'assets/question.svg',
  QUESTION_COMPLETED: 'assets/question-completed.svg',
  V: 'assets/v.svg',
  ENVELOPE: 'assets/envelope.svg',
  FORM_COMPLETED: 'assets/form-completed.svg',
  TOOLTIP: 'assets/information-circle.svg',
  TOOLTIP_GREY: 'assets/information-circle-grey.svg',
  SHORT_TERM_PRODUCT: 'assets/icons/short-term-product.svg',
  SHORT_TERM_PRODUCT_SELECTED: 'assets/icons/short-term-product-selected.svg',
  LONG_TERM_PRODUCT: 'assets/icons/long-term-product.svg',
  LONG_TERM_PRODUCT_SELECTED: 'assets/icons/long-term-product-selected.svg',
  STUDENT_PRODUCT: 'assets/icons/student-product.svg',
  STUDENT_PRODUCT_SELECTED: 'assets/icons/student-product-selected.svg',
  RED_SUCCESS: 'assets/icons/red-success-v.svg',
  RED_ERROR: 'assets/icons/red-error-circle.svg',
  FLIGHT_DELAY_AIRPLANE_MOBILE: 'assets/icons/flight-delay-airplane-mobile.svg',
  FLIGHT_DELAY_AIRPLANE_DESKTOP: 'assets/icons/flight-delay-airplane-desktop.svg',
  ERROR_ICON: 'assets/icons/error.svg',
  PASSPORT_CARD_COVER: 'assets/icons/passport-card-cover.svg',
  CIRCLE_CHECK: 'assets/icons/circle-check.svg',
  CIRCLE_CHECK_RED: 'assets/icons/circle-check-red.svg',
  PASSPORTCARD_CARD: 'assets/PassportCard-card.svg',
  RED_CIRCLE_CHECK: 'assets/icons/red-circle-check.svg',
  RED_CIRCLE_INVALID: 'assets/icons/red-circle-invalid.svg',
  BLACK_LEFT_ARROW: 'assets/icons/black-left-arrow.svg',
  EMAIL_SIGNATURE: 'assets/icons/email-signature-icon.svg',
  EMAIL_SIGNATURE_SELECTED: 'assets/icons/email-signature-icon-selected.svg',
  CHECK_GUARD: 'assets/icons/check-guard.svg',
  INVOICE_OUTLINE: 'assets/icons/invoice-outline.svg',
  QUESTION_CIRCLE_BLACK: 'assets/icons/question_circle_black.svg',
  RED_ARROW_LEFT_CIRCLE: 'assets/icons/red_arrow_circle.svg',
  CREDIT_CARD_BACKSIDE_ICON: 'assets/icons/creditcard-backside-icon.svg',
  PASSPORTCARD_IL: 'assets/icons/passporcard_il.png'
};

export const PcImages = {
  NAVBAR_MOBILE_LOGO: 'assets/images/logos/pc-mobile-logo.svg',
  NAVBAR_DESKTOP_LOGO: 'assets/images/logos/pc-desktop.svg',
  NAVBAR_DESKTOP_EXPAND_LOGO: 'assets/images/logos/pc-desktop-expand.png',
  EMPTY_LIST: 'assets/images/empty-list.png',
  EMPTY_LIST_V2: 'assets/images/empty-list-v2.png',
  POLICY_ERROR_DESKTOP: 'assets/images/policy-error-desktop.png',
  POLICY_ERROR_MOBILE: 'assets/images/policy-error-mobile.png',
  CREDIT_CARD_ERROR_DESKTOP: 'assets/images/credit-card-error-desktop.jpg',
  CREDIT_CARD_ERROR_MOBILE: 'assets/images/credit-card-error-mobile.jpg',
  SAPIR: 'assets/images/sapir.svg',
  DESKTOP_BACKGROUND_IMAGE: 'assets/images/desktop-background-image.jpg',
  MOBILE_BACKGROUND_IMAGE: 'assets/images/mobile-background-image.jpg',
  DESKTOP_BACKGROUND_IMAGE_AU: 'assets/images/desktop-bg-image-au-sales.png',
  MOBILE_BACKGROUND_IMAGE_AU: 'assets/images/mobile-bg-image-au-sales.png',
  PRE_EX_MOBILE: 'assets/images/pre-ex-mobile.jpg',
  PRE_EX_DESKTOP: 'assets/images/pre-ex-desktop.jpg',
  CONTACT_US_DESKTOP: 'assets/images/contact-us-desktop.jpg',
  CONTACT_US_MOBILE: 'assets/images/contact-us-mobile.jpg',
  LEG_SKIING_MOBILE: 'assets/images/leg-skiing-mobile.jpg',
  LEG_SKIING_DESKTOP: 'assets/images/leg-skiing-desktop.jpg',
  ANGEBOT_DESKTOP_BG_IMAGE_PRODUCTS: 'assets/images/desktop-bg-image-products.jpg',
  ANGEBOT_MOBILE_BG_IMAGE_PRODUCTS: 'assets/images/mobile-bg-image-products.jpg',
  ANGEBOT_DESKTOP_BG_IMAGE_LONG_TERM: 'assets/images/desktop-bg-image-long-term.jpg',
  ANGEBOT_MOBILE_BG_IMAGE_LONG_TERM: 'assets/images/mobile-bg-image-long-term.jpg',
  ANGEBOT_DESKTOP_BG_IMAGE_SHORT_TERM: 'assets/images/desktop-bg-image-short-term.jpg',
  ANGEBOT_MOBILE_BG_IMAGE_SHORT_TERM: 'assets/images/mobile-bg-image-short-term.jpg',
  ANGEBOT_DESKTOP_BG_IMAGE_STUDENT: 'assets/images/desktop-bg-image-student.jpg',
  ANGEBOT_MOBILE_BG_IMAGE_STUDENT: 'assets/images/mobile-bg-image-student.jpg',
  ANGEBOT_DESKTOP_ERROR_POPUP: 'assets/images/desktop-angebot-error-popup.jpg',
  ANGEBOT_MOBILE_ERROR_POPUP: 'assets/images/mobile-angebot-error-popup.jpg',
  PASSPORTCARD_CARD: 'assets/images/passportcard-card.svg',
  SESSION_TIMEOUT_DESKTOP: 'assets/images/session-timeout-desktop.jpg',
  SESSION_TIMEOUT_MOBILE: 'assets/images/session-timeout-mobile.jpg',
  AGENT_DISCLAIMER_DESKTOP: 'assets/images/broker-recording-desktop.jpg',
  AGENT_DISCLAIMER_MOBILE: 'assets/images/broker-recording-mobile.jpg',
  READ_MORE_DESKTOP: 'assets/images/read-more-desktop.png',
  READ_MORE_MOBILE: 'assets/images/read-more-mobile.jpg',
  INFO_IMAGE: 'assets/images/info.svg',
  DESKTOP_BACKGROUND_COLLINSON_IMAGE: 'assets/images/desktop-background-collinson-img.jpg',
  MOBILE_BACKGROUND_COLLINSON_IMAGE: 'assets/images/mobile-background-collinson-img.jpg',
  BACKGROUND_ACCESSIBILITY_IMAGE: 'assets/images/accessibility-background-img.jpg',
  PASSPORTCARD_LOGO: 'assets/images/passportcard-subtitle.png',
  PASSPORTCARD_LOGO_POPUP: 'assets/images/passportcard-subtitle-popup.png',
  CONTACT_US_LONG_DESKTOP: 'assets/images/contact-us-long-desktop.png',
  PROCESS_DESKTOP: 'assets/images/process-desktop.png',
  CONTACT_US_LONG_MOBILE: 'assets/images/contact-us-long-mobile.png',
  PROCESS_MOBILE: 'assets/images/process-mobile.png',
  AIRPLANE_DASHED_LINE: 'assets/images/airplane-dashed-line.svg',
  AIRPLANE_DASHED_LINE_DISABLED: 'assets/images/airplane-dashed-line-disabled.svg',
  LOCATE_FLIGHT_DESKTOP: 'assets/images/locate-flight-desktop.png',
  WARNING_ICON: 'assets/images/warning-icon.svg',
  FLIGHT_DELAY_ERROR_DESKTOP: 'assets/images/flight-delay-error-desktop.png',
  FLIGHT_DELAY_ERROR_MOBILE: 'assets/images/flight-delay-error-mobile.png',
  BEACH_UMBRELLA: 'assets/images/beach-umbrella.svg',
  SNOW_SPORTS_DESKTOP: 'assets/images/snow-sports-desktop.svg',
  SNOW_SPORTS_MOBILE: 'assets/images/snow-sports-mobile.svg',
  TAX_REFUND_QUESTIONS: 'assets/images/tax-refund-questions.png',
  TAX_REFUND_QUESTIONS_MOBILE: 'assets/images/tax-refund-questions-MOBILE.png',
  PASSPORTCARD_CREDIT_CARD: 'assets/images/passportcard-cradit-card.png',
  GOOGLE_PLAY: 'assets/images/googleplay.png',
  APP_STORE: 'assets/images/appstore.png',
  QR_LOUNGE: 'assets/images/QR_lounge.png'
};

export const PcAlertsImages = {
  Desktop_PregnancyCoverage: 'assets/images/alerts/Desktop_pregnancyCoverage.jpg',
  PregnancyCoverage: 'assets/images/alerts/pregnancyCoverage.jpg',
  Desktop_CardBlocked: 'assets/images/alerts/cardBlocked.png',
  CardBlocked: 'assets/images/alerts/cardBlocked.png',
  Desktop_isSearchAndRescueCoverAllowed: 'assets/images/alerts/Desktop_isSearchAndRescueCover.jpg',
  isSearchAndRescueCoverAllowed: 'assets/images/alerts/isSearchAndRescueCover.jpg',
  Desktop_isSearchAndRescueCoverDisabled: 'assets/images/alerts/Desktop_isSearchAndRescueCoverDisabled.jpg',
  isSearchAndRescueCoverDisabled: 'assets/images/alerts/isSearchAndRescueCoverDisabled.jpg',
  Desktop_isSearchAndRescueDisallowedCountries: 'assets/images/alerts/Desktop_isSearchAndRescueCover.jpg',
  isSearchAndRescueDisallowedCountries: 'assets/images/alerts/isSearchAndRescueCover.jpg',
  Desktop_7: 'assets/images/alerts/desktop/adventure_activities.jpg',
  Mobile_7: 'assets/images/alerts/mobile/adventure_activities.jpg',
  Desktop_9: 'assets/images/alerts/desktop/business_cover.jpg',
  Mobile_9: 'assets/images/alerts/mobile/business_cover.jpg',
  Desktop_CancellationExtra: 'assets/images/alerts/desktop/cancellation_extra.jpg',
  Mobile_CancellationExtra: 'assets/images/alerts/mobile/cancellation_extra.jpg',
  Desktop_98: 'assets/images/alerts/desktop/choose_your_excess.jpg',
  Mobile_98: 'assets/images/alerts/mobile/choose_your_excess.jpg',
  Desktop_12: 'assets/images/alerts/desktop/concerts_other_events.jpg',
  Mobile_12: 'assets/images/alerts/mobile/concerts_other_events.jpg',
  Desktop_4: 'assets/images/alerts/desktop/cruise_cover.jpg',
  Mobile_4: 'assets/images/alerts/mobile/cruise_cover.jpg',
  Desktop_8: 'assets/images/alerts/desktop/golf.jpg',
  Mobile_8: 'assets/images/alerts/mobile/golf.jpg',
  Desktop_95: 'assets/images/alerts/desktop/included_activities.jpg',
  Mobile_95: 'assets/images/alerts/mobile/included_activities.jpg',
  Desktop_2: 'assets/images/alerts/desktop/luggage_personal_belongings_suitcase.jpg',
  Mobile_2: 'assets/images/alerts/mobile/luggage_personal_belongings_suitcase.jpg',
  Desktop_PersonalBelongingsSuitcase: 'assets/images/alerts/desktop/luggage_personal_belongings.jpg',
  PersonalBelongingsSuitcase: 'assets/images/alerts/mobile/luggage_personal_belongings.jpg',
  Desktop_MobilePhoneCover: 'assets/images/alerts/desktop/mobile_phone_cover.jpg',
  MobilePhoneCover: 'assets/images/alerts/mobile/mobile_phone_cover.jpg',
  Desktop_ValuableItems: 'assets/images/alerts/desktop/other_valuable_items.jpg',
  ValuableItems: 'assets/images/alerts/mobile/other_valuable_items.jpg',
  Desktop_PersonalAccidents: 'assets/images/alerts/desktop/personal_accident_cover.jpg',
  PersonalAccidents: 'assets/images/alerts/mobile/personal_accident_cover.jpg',
  Desktop_PersonalLiability: 'assets/images/alerts/desktop/personal_liability.jpg',
  PersonalLiability: 'assets/images/alerts/mobile/personal_liability.jpg',
  Desktop_20: 'assets/images/alerts/desktop/pet_care.jpg',
  Mobile_20: 'assets/images/alerts/mobile/pet_care.jpg',
  Desktop_PriceDrop: 'assets/images/alerts/desktop/price_drop.jpg',
  PriceDrop: 'assets/images/alerts/mobile/price_drop.jpg',
  Desktop_ReferToSales: 'assets/images/alerts/desktop/refer_to_sales.jpg',
  ReferToSales: 'assets/images/alerts/mobile/refer_to_sales.jpg',
  Desktop_6: 'assets/images/alerts/desktop/search_rescue.jpg',
  Mobile_6: 'assets/images/alerts/mobile/search_rescue.jpg',
  Desktop_5: 'assets/images/alerts/desktop/snow_sports.jpg',
  Mobile_5: 'assets/images/alerts/mobile/snow_sports.jpg',
  Desktop_18: 'assets/images/alerts/desktop/water_sports.jpg',
  Mobile_18: 'assets/images/alerts/mobile/water_sports.jpg',
  Desktop_19: 'assets/images/alerts/desktop/wheeled_activities.jpg',
  Mobile_19: 'assets/images/alerts/mobile/wheeled_activities.jpg',
  Desktop_GetInTouch: 'assets/images/alerts/desktop/get_in_touch_desktop.jpg',
  GetInTouch: 'assets/images/alerts/mobile/get_in_touch_mobile.jpg',
  Desktop_1: 'assets/images/alerts/desktop/overseas_medical_dental.jpg',
  Mobile_1: 'assets/images/alerts/mobile/overseas_medical_dental.jpg',
  Desktop_21: 'assets/images/alerts/desktop/rental_vehicle_excess.jpg',
  Mobile_21: 'assets/images/alerts/mobile/rental_vehicle_excess.jpg',
  Desktop_99: 'assets/images/alerts/desktop/the_passportcard.jpg',
  Mobile_99: 'assets/images/alerts/mobile/the_passportcard.jpg',
  Mobile_Preex: 'assets/images/alerts/mobile/the_preex.jpg',
  Desktop_Preex: 'assets/images/alerts/desktop/the_preex.jpg',
  Desktop_3: 'assets/images/alerts/desktop/trip_cancellation_delay.jpg',
  Mobile_3: 'assets/images/alerts/mobile/trip_cancellation_delay.jpg'
};

export const PcLottieAnimations = {
  confetti: 'assets/lottie/confeti_blown_up.json',
  creditCard: 'assets/lottie/credit_card.json',
  coins: 'assets/lottie/coins.json'
};

export const GLOBAL_BREAKPOINTS = {
  MEDIUM: 720,
  XMEDIUM: 814,
  LARGE: 1024,
  XLARGE: 1366
};

export const defaultGradientBtnConfig: IGradientBtnConfig = {
  buttonType: 'primary',
  text: '',
  icon: '',
  flipIcon: false,
  invertIconColor: false,
  isDisabled: false,
  isLoading: false,
  isTextImageReverseOrder: false,
  width: 16,
  height: 16
};

export const DYNAMIC_FORMATS = {
  parse: {
    dateInput: EDateFormat.FORMAT_DDMMYYY
  },
  display: {
    dateInput: EDateFormat.FORMAT_DDMMYYY,
    monthYearLabel: EDateFormat.MONTH_YEAR_LABEL_MMMYYYY,
    dateA11yLabel: EDateFormat.DATE_ACCESSIBILITY_LABEL_LL,
    monthYearA11yLabel: EDateFormat.MONTH_YEAR_ACCESSIBILITY_LABEL_MMMM_YYYY
  }
};

export const IS_ANDROID = Capacitor.getPlatform() === Platform.ANDROID;
export const IS_IOS = Capacitor.getPlatform() === Platform.IOS;
export const IS_NATIVE_APP = Capacitor.isNativePlatform();
export const BIOMETRIC_SESSION_TIMEOUT_MS = 600000;
export const MAX_SIZE_CAROUSEL_ARRAY = 3;
